import intersection from 'lodash/intersection';
import without from 'lodash/without';
import uniq from 'lodash/uniq';

const syndeticsUnbound = (() => {
  let loadScriptPromise = null;

  const SUPPORTED_ENRICHMENT_IDS = {
    AUDIO_VIDEO: 'audiovideo',
    AUTHOR: 'author',
    AWARDS: 'awards',
    GAME: 'game',
    LOOK_INSIDE: 'lookinside',
    METRICS: 'altmetrics',
    PROFILE: 'bookprofile',
    REVIEWS: 'reviews',
    RESOURCES_FOR_COLLEGE_LIBRARIES: 'rcl',
    READING_LEVEL: 'readinglevel',
    SERIES: 'series',
    SIMILAR: 'similar',
    SUMMARY: 'summary',
    TAGS: 'tags',
    SHELF_BROWSE: 'shelfbrowse'
  };

  const makeScriptUrl = (accountId, instanceId) => {
    const queryParams = new URLSearchParams({ a_id: accountId });

    if (instanceId) {
      queryParams.append('i_id', instanceId);
    }

    return `https://unbound.syndetics.com/syndeticsunbound/connector/initiator.php?${queryParams.toString()}`;
  };

  const libraryThingConnectorAdapter = {
    getAvailableEnrichmentIds: ({ excludeIds = [] } = {}) => {
      const enabledEnrichmentIds = uniq(window.LibraryThingConnector.enrichmentsOn() || []);

      return without(intersection(enabledEnrichmentIds, Object.values(SUPPORTED_ENRICHMENT_IDS)), ...excludeIds);
    },
    isEnrichmentShown: enrichmentId => {
      return window.LibraryThingConnector.isEnrichmentShown(enrichmentId);
    },
    populate: ({ isbn, upc }) => {
      window.LibraryThingConnector.runUnboundWithMetadata({
        isbn,
        unbound_run_link_function: destination => {
          const url = new URL(destination);
          const query = url.searchParams.get('query');
          const matches = /^ISBN:(\d+)$/.exec(query);
          const bibIsbn = matches?.[1];

          window.location = bibIsbn
            ? new URL(`/item/show_by_isbn/${bibIsbn}`, window.location.origin).toString()
            : destination;
        },
        upc
      });
    }
  };

  const initialize = (accountId, instanceId) => {
    if (!accountId) {
      throw new Error('A SyndeticsUnbound Account ID is required');
    }

    if (loadScriptPromise) {
      return loadScriptPromise;
    }

    loadScriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = makeScriptUrl(accountId, instanceId);
      script.async = true;
      script.onload = () => {
        if (!window?.LibraryThingConnector) {
          reject(new Error('Failed to load SyndeticsUnbound LibraryThingConnector'));
        }

        resolve(libraryThingConnectorAdapter);
      };

      document.body.appendChild(script);
    });

    return loadScriptPromise;
  };

  return { initialize, SUPPORTED_ENRICHMENT_IDS };
})();

export default syndeticsUnbound;
